import type { SVGProps } from "react";
export interface PlaneIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PlaneIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PlaneIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.133 1.875c1.085 0 2.093.563 2.662 1.487l3.085 5.013H18c1 0 2.193.394 3.124.931.476.275.945.62 1.307 1.033.354.402.695.97.695 1.661s-.341 1.26-.695 1.661c-.362.412-.83.758-1.306 1.033-.932.537-2.125.931-3.125.931h-2.12l-3.085 5.013a3.13 3.13 0 0 1-2.662 1.487H8.928a1.625 1.625 0 0 1-1.553-2.104l1.352-4.396H6.771L5.688 16.71a3.13 3.13 0 0 1-2.21.916H2.5a1.626 1.626 0 0 1-1.542-2.139L2.119 12 .958 8.514A1.625 1.625 0 0 1 2.5 6.375h.977l.31.015a3.13 3.13 0 0 1 1.9.9l1.084 1.085h1.956L7.375 3.979a1.625 1.625 0 0 1 1.553-2.104zm1.193 7.293a1.126 1.126 0 0 1-1.075 1.456H6.306c-.299 0-.585-.118-.796-.33L4.097 8.882a.88.88 0 0 0-.62-.256h-.111l1.008 3.019c.077.231.077.481 0 .712l-1.008 3.019h.111l.171-.018a.88.88 0 0 0 .449-.238l1.413-1.414.172-.14c.183-.123.4-.19.624-.19h3.945a1.126 1.126 0 0 1 1.075 1.457l-1.552 5.043h.36a.88.88 0 0 0 .745-.416l3.415-5.549.083-.119c.212-.261.533-.415.874-.415h2.75c.5 0 1.307-.232 2.001-.632.336-.194.587-.396.74-.57a.8.8 0 0 0 .124-.174.8.8 0 0 0-.124-.174 3 3 0 0 0-.74-.57c-.694-.4-1.5-.632-2.001-.632h-2.75c-.39 0-.753-.202-.957-.534L10.878 4.54a.88.88 0 0 0-.746-.416h-.359l1.552 5.043Z"
      />
    </svg>
  );
}
